<template>
  <v-row>
    <v-col cols="12">
      <div
        style="
          font-size: 28px;
          padding-left: 40px;
          padding-right: 40px;
          text-align: center;
          margin: 20px 0;
          color: #1b428b;
          font-weight: bold;
        "
      >
        Here is {{ report_period }} report from {{ platform }}
      </div>
      <div style="margin: 0 16px 20px 16px">
        <div>
          <span style="font-size: 17px; color: #0581c6">Client: </span><span style="font-size: 16px">{{ tenant }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">Report Date: </span>
          <span style="font-size: 16px">{{ report_date }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">Report Generated At: </span>
          <span style="font-size: 16px">{{ report_time }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">Recepients: </span>
          <span style="font-size: 16px">{{ final_recepient }}</span>
          <span v-if="recipients_number" style="font-size: 12px; color: #0581c6">
            ...+{{ recipients_number }} more</span
          >
        </div>
      </div>
    </v-col>
    <v-col cols="12">
      <div
        style="
          font-size: 24px;
          padding-left: 40px;
          padding-right: 40px;
          text-align: center;
          color: #1b428b;
          font-weight: bold;
        "
      >
        Report at a glance:
        <div class="primaryGrey--text text-caption">(1 Week : {{ report_beginning_date }} to {{ report_date }})</div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ScavengerReportHeading",
  props: {
    platform: String,
    report_period: String,
    tenant: String,
    report_date: String,
    report_time: String,
    final_recepient: String,
    recipients_number: Number,
    report_beginning_date: String,
  },
};
</script>
